import { mergeClassName as e } from "../../utils/data.js";
import t from "./Column.module.js";
import { jsxDEV as n } from "react/jsx-dev-runtime";
//#region lib/components/Layout/Column.tsx
var r = "/opt/render/project/src/shared-ui/lib/components/Layout/Column.tsx";
function i({ children: i, spacing: a = 3, className: o, style: s, ...c }) {
	return /* @__PURE__ */ n("div", {
		...c,
		style: {
			gap: `var(--ag-spacing-${String(a)})`,
			...s
		},
		className: e(t.column, o),
		children: i
	}, void 0, !1, {
		fileName: r,
		lineNumber: 13,
		columnNumber: 9
	}, this);
}
//#endregion
export { i as Column };
